import { Link } from "react-router-dom"
import { config } from "../lib/config"

export const TermosPage = () => {
  return (
    <main className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <Link to="/" className="text-sm font-medium text-brand-600 hover:underline">
          ← Voltar
        </Link>
        <h1 className="mt-6 text-3xl font-bold text-slate-900">Termos de uso</h1>
        <p className="mt-2 text-sm text-slate-500">Rascunho Fase 0 — revisão jurídica antes do go-live.</p>
        <div className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed text-slate-700">
          <p>
            Ao utilizar o {config.appName}, você concorda em usar a plataforma conforme a legislação fiscal
            brasileira e as políticas de segurança descritas na documentação técnica.
          </p>
          <p>
            O serviço é oferecido pela MundoApps. O cliente é responsável pela veracidade dos dados fiscais
            transmitidos e pelo uso adequado de certificados digitais.
          </p>
          <p>
            Suporte:{" "}
            <a href={`mailto:${config.supportEmail}`} className="text-brand-600 hover:underline">
              {config.supportEmail}
            </a>
          </p>
        </div>
      </div>
    </main>
  )
}
